export default __webpack_public_path__ + "static/media/vision.d9722785.png";